<template>
    <div class="productsPageCon">
     
         <Card>
             <div v-show="offModel">
                 <!-- 搜索 -->
                <div class="search-div flexC">
        
                     <div class="search-div-item flexC">
                        <div class="labelText">{{$t("BasicProduct.titleName.basicClassId")}}</div>
                        <Cascader :data="basicClassIdList" v-model="searchObj.basicClassIdArr" change-on-select ></Cascader>
                    </div>

                    <div class="search-div-item flexC">
                       <div class="labelText" >  {{$t("BasicProduct.titleName.basicName") }}</div>
                       <Input  class="input-div"  :placeholder="$t('inputPlaceholder')"  clearable  v-model="searchObj.basicName"></Input>
                     </div>
                     
                    <div class="search-div-item flexC">
                       <div class="labelText" >  {{$t("BasicProduct.titleName.disabled") }}</div>
                       <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="searchObj.forbidden" >
                            <Option v-for="(item, index) in selectObj.disableList" :value="item.id" :key="index">{{item['val']}}</Option>
                        </Select>
                     </div>
        
                     <div class="search-div-item">
                        <Button type="info" @click="searchItem"  icon="ios-search" style="margin-top:5px;height:44px;line-height:44px;width:96px;border-radius: 10px;">{{$t('search')}}</Button>
                     </div>
                 
                </div>
                <div>
                   <Button type="success" class="addButton" @click="addData(1)" style="margin-right:8px;">{{$t("BasicProduct.addBox.title")}}</Button>
                   <Button type="primary" class="addButton" :disabled="buttonList.editDisabled" @click="addData(2)" style="margin-right:8px;">{{$t("BasicProduct.addBox.title1")}}</Button>

                   <Button type="info" class="addButton"  @click="addFunc" style="margin-right:8px;">{{$t("BasicProduct.addBox.title2")}}</Button>
                </div>
                <div>
                    <Table style="width: 100%;margin-top: 30px;"  :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'  @on-selection-change="selectChange"></Table>
                    <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,15,20]" placement="top" class="pages"/>
                </div>


             </div>

            <!-- 新增、编辑 -->
           <ModelBox :showModel.sync="addBox.showModel"  :offModel.sync='offModel' :type="type"  :editFormData="addBox.editFormData" :fn="addBox.callbackFn" ></ModelBox>
   
   
           <!-- 删除 -->
           <DeleteDialog ref="deleteChild" @ievent = "ievent"  ></DeleteDialog>

           <!-- 功能 -->
           <FuncModelBox :showModel.sync="funcBox.showModel"  :offModel.sync='offModel' :editFormData="funcBox.editFormData" :fn="funcBox.callbackFn"></FuncModelBox>

           <!-- 通用功能 -->
           <GeneralFuncBox :showModel.sync="addFuncBox.showModel"  :offModel.sync='offModel' :fn="addFuncBox.callbackFn"></GeneralFuncBox>


           <!-- 吕伟平台功能，不分类型，直接展示 -->
           <HyecoFuncBox :showModel.sync="hyecoFuncBox.showModel"  :offModel.sync='offModel' :editFormData="hyecoFuncBox.editFormData" :fn="hyecoFuncBox.callbackFn"></HyecoFuncBox>


          
           
        </Card>

     

      

    </div>
   
</template>

<script>

import common from '@/common/common.js';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import ModelBox from './component/addModel.vue'; // 新增、编辑
import FuncModelBox from './component/funcModelBox.vue'; // 功能
import GeneralFuncBox from './component/generalFuncBox.vue'; // 通用功能
import HyecoFuncBox from './component/hyecoFuncBox.vue'; // hyeco 吕伟平台功能，不分类型，直接展示
import moment from 'moment'
import { mapState,mapMutations } from 'vuex'
import {toTree} from "@/libs/tools.js"
import store from '@/store'
    export default {
        name: "productsAdmin",
        components: {
            DeleteDialog,
            ModelBox,
            FuncModelBox,
            GeneralFuncBox,
            HyecoFuncBox
        },
        data(){
            return{
                loading: true,
                offModel: true,
                type:1,
                basicClassIdList:[],//基础分类列表
                basicClassIdItem:[],//上一级
                basicClassIdList1:null,//基础分类列表
                topId:null,
                paging:true,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:10,//每页条数
                    current:1,//当前页
                    key:'id',
                    order:'desc'
                },
                searchObj:{
                    basicName:'',
                    basicClassIdArr:[],
                    forbidden:''
                },
                buttonList:{//按钮组
                    addDisabled:false,//添加按钮是否禁用
                    editDisabled:true,//编辑按钮是否禁用
                    delDisabled:true,//删除按钮是否禁用
                },
                tableList:{
                    tableData:[],
                    tableDataAll:[],
                    hasSelectData:{}
                },
              
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                addFuncBox:{//规格弹框组-通用功能
                    showModel:false,//弹框开关
                    callbackFn:()=>{}//弹框的回调函数
                },
                funcBox:{//规格弹框组
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//传入的现有数据
                    type:1,
                },
                hyecoFuncBox:{//规格弹框组
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//传入的现有数据
                },
                passwordModelBox:{
                    showModel:false,//弹框开关
                    password:'',
                    disabled:false,
                    editFormData:{},//编辑时传入的现有数据
                }
            }
        },
        computed:{
            ...mapState(['local','selectId','uInfo','pageIdStore']),
            roleType(){
	        	 let res = '2'
	        	 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        		 res = this.$store.state.uInfo.roleType
	        	 }
	        	 return res
	         },
             selectObj(){
                return {
                    disableList:[
                        {id: 'true',val:this.$t('selectList.MustedList.true')},
                        {id: 'false',val:this.$t('selectList.MustedList.false')},
                    ]
                }
            },
          
            titleName(){
                return [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
         
                    {
                        title: this.$t('BasicProduct.titleName.Id'),
                        key: 'id',
                        width: 140,
                        sortable: true,
                        tree: true
                    },
                    {
                        title: this.$t('BasicProduct.titleName.disabled'),
                        key: 'forbidden',
                        width: 130,
                        render:(h, params)=>{
                             let stext = params.row.forbidden==true?this.$t("yes"):this.$t("no")
                             return h('div',{
                                style:{
                                    color:params.row.forbidden==true?"#ed4014":""
                                }
                             },stext || '')
                        }
                    },
                    {
                        title: this.$t('BasicProduct.titleName.basicName'),
                        key: 'basicName',
                        width: 140,
                        sortable: true,
                        render:(h, params)=>{
                            let stext = params.row.basicName
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    {
                        title: this.$t('BasicProduct.titleName.baseNick'),
                        key: 'baseNick',
                        width: 240,
                        render:(h, params)=>{
                            let stext = params.row.baseNick || ''
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    {
                        title: this.$t('BasicProduct.titleName.comType'),
                        key: 'comMode',
                        width: 260,
                        render:(h, params)=>{
                           let stext = ""
                           try {
                            if(params.row.comType){
                                let comTypeTextObj = JSON.parse(params.row.comType)
                                stext = `↑:${comTypeTextObj[0]["UP"]} / ↓:${comTypeTextObj[1]["DOWN"]}`
                            }
                           } catch (error) {
                            
                           }
                           

                            return h('div',{
                                attrs:{
                                    title:stext
                                },
                               
                            },stext || '')
                        }
                    },
                   
                  
                    {
                        title: this.$t('BasicProduct.titleName.connectMode'),
                        key: 'connectMode',
                        width: 200,
                        render:(h, params)=>{
                            
                            let TypeList = {'1':'Not_networked','2':'Gateway','3':'Gateway_device','4':'direct-connected_facility','5':'base_station','6':'base_station_facility'}
                            let nameFlag = TypeList[params.row.connectMode]
                            let stext = ''
                            if(!nameFlag){
                                stext =params.row.connectMode
                            }else{
                                stext =this.$t('selectList.connectListBasic.'+nameFlag) 
                            }
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                     {
                        title: this.$t('BasicProduct.titleName.designImplType'),
                        key: 'designImplType',
                        width: 190,
                        render:(h, params)=>{
                            let stext = '' 
                            let designImplTypeList = {
                                "1":this.$t('selectList.designImplTypeList.type1'),
                                "2":this.$t('selectList.designImplTypeList.type2'),
                                "3":this.$t('selectList.designImplTypeList.type3'),
                                "4":this.$t('selectList.designImplTypeList.type4'),
                                "5":this.$t('selectList.designImplTypeList.type5'),
                            }
                            
                            stext = designImplTypeList[params.row.designImplType] || params.row.designImplType

                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    {
                        title: this.$t('BasicProduct.titleName.loraProductKey'),
                        key: 'loraProductKey',
                        width: 160,
                        render:(h, params)=>{
                            let loraProductKey = ['A6k_t3Rng','u_ElpqR7R','HJTutqgnR','aYFrpqg7g','None']
                            let nameFlag = loraProductKey.indexOf(params.row.loraProductKey)
                            let stext = ''
                            if(nameFlag<0){
                                stext =params.row.loraProductKey
                            }else{
                                stext =this.$t('selectList.loraProductKeyBasic.'+params.row.loraProductKey) 
                            }
                            // console.log('name',nameFlag)
              
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    
                    {
                        title: this.$t('BasicProduct.titleName.majorKey'),
                        key: 'majorKeyId',
                        minWidth: 170
                    },
                   
                    {
                        title: this.$t('productPage.titleName.Remark'),
                        key: 'remark',
                        minWidth: 220
                    },
                    {
		            	title: this.$t('productPage.titleName.Operation'),
                        'title-zh-CN':'操作',
                        'title-en-US':'Operation',
                        fixed:'right',
		            	width:220,
                        key: "Operation",
		            	render: (h, params) => {
                            let that = this
                            return h('div',{
                                style:{
                                    display:'flex',
                                    'justify-content':'center'
                                }
                            },[
                                
                                h('Poptip', 
                                       {
                                            props: {
                                                confirm: true,
                                                transfer:true,
                                                // 'ok-text':"yes",
                                                // 'cancel-text':"no",
                                                type: 'error',
                                                size: 'large',
                                                title: that.$t("productManage.popTitle")
                                            },
                                            on: {
                                                'on-ok': () => {
                                                    this.publishProduct(params.row)
                                                }
                                            }
                                        }, 
                                        [
                                            h('Button', {
                                                props: {
                                                    type: 'primary',
                                                    size: 'small',
                                                    disabled: params.row.published
                                                },
                                                style: {
                                                    marginRight: '5px',
                                                    // display:params.row.published?'none':'inline-block'
                                                },
                                            },that.$t("productManage.addModel.Publish"))
                                       ]
                                ),
                                // h('Button',{
		            	        //       props: {
                                //           type: "info",
                                //           size: 'small'
                                //       },
                                //       style:{
                                //           marginRight: '5px',
                                //           display:!params.row.published?'none':'inline-block'
                                //       },
		            	        //       on: {
		            	        //           click: () => { 
                                //               this.editModel(params.row)
                                //            }
		            	        //       }
		            	        //   },that.$t("edit")),
                                h('Button',{
		            	              props: {
                                          type: "error",
                                          size: 'small',
                                          disabled: params.row.published
                                      },
                                      style:{
                                          marginRight: '5px'
                                      },
		            	              on: {
		            	                  click: () => { 
                                              this.todelData(params.row)
                                           }
		            	              }
		            	          },that.$t("delete")),
                                  h('Button',{
		            	              props: {
                                          type: "primary",
                                          size: 'small'
                                      },
                                      style:{
                                      },
		            	              on: {
		            	                  click: () => { 
                                              this.showFunc(params.row,1)
                                           }
		            	              }
		            	          },that.$t("productManage.addModel.Function_Editor"))
                            ])
		            	}
		        
                    },
                   
                    
                ]
             } 
        },
        mounted(){
        },
        async created(){
   
            this.getData()
            this.getCate1()
            console.log('pageid',this.pageIdStore)
        },
        watch: {

        },
        beforeRouteEnter:(to,from,next)=>{
            let role = store.state.uInfo.roleType==1?'admin':'user'
            if(to.meta.roles.includes(role)){
                next() //放行
            }else{
                next({path:"/404"}) //跳到404页面
            }
        },
        methods: {
            ...mapMutations(['setPageId']),
            async getCate1(){//获取全部分类数据
                 let res = await this.axios.post(this.config.urlArray.typeCateList, {parentClassId:null})
                
                 common.ajaxMsg(res.data,false,()=>{
                    this.basicClassIdList1 = res.data.data
                    this.basicClassIdList = toTree(this.basicClassIdList1)
                 },()=>{

                 })

                 
            },
            searchItem(){//搜索
               this.loading = true
               this.page.current = 1
               this.page.pageSize = 10
               this.getData()
            },
            showFunc(row,type){//功能
                if(this.roleType==2) return
                this.offModel = false
                this.setPageId(row.pageId)
                

                // this.hyecoFuncBox.showModel = true
                // this.hyecoFuncBox.editFormData = row
                // this.hyecoFuncBox.type = type
                // this.hyecoFuncBox.callbackFn = () => {//回调处理
                //     //重新载入
                //     this.hyecoFuncBox.showModel = false;
                //     // this.getData();
                // }



                if(row.communicateProtocol==3){
                    this.hyecoFuncBox.showModel = true
                    this.hyecoFuncBox.editFormData = row
                    this.hyecoFuncBox.type = type
                    this.hyecoFuncBox.callbackFn = () => {//回调处理
                        //重新载入
                        this.hyecoFuncBox.showModel = false;
                        // this.getData();
                    }
                }else{

                    this.funcBox.showModel = true
                    this.funcBox.editFormData = row
                    this.funcBox.type = type
                    this.funcBox.callbackFn = () => {//回调处理
                        //重新载入
                        this.addBox.showModel = false;
                        // this.getData();
                    }
                }

                
            },
            todelData(item) {// 删除
                this.tableList.hasSelectData = item
                this.$refs.deleteChild.showit();
            },
            ievent() {// 删除
                // console.log('删除，下面注释掉了',this.tableList.hasSelectData)
                this.axios.post(this.config.urlArray.basicProductsDel, {id:this.tableList.hasSelectData.id}).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    // common.msg('error','删除失败')
                })
            },
            publishProduct(item){//发布
           
                this.axios.post(this.config.urlArray.basicProductsPub, {id:item.id}).then((result) => {
                    common.ajaxMsg(result.data,true);
                    this.getData()
                    
                })
            },
            editModel(item){//修改，需要输入管理员密码
                this.passwordModelBox.showModel = true
                this.passwordModelBox.editFormData = item
            },
            handleSubmit(){
                if(this.passwordModelBox.password.length<6){
                    this.$Message.error('密码长度不能少于6位')
                    return
                }
                this.passwordModelBox.disabled = true
            
                if(this.passwordModelBox.password.length>=6){
                    this.passwordModelBox.showModel = false
                    this.passwordModelBox.password = ''
                    this.passwordModelBox.disabled = false
                }
                
            },
            handleCancel(){
                this.passwordModelBox.showModel = false
            },
            addData(type) {  //添加或编辑数据
               if(this.roleType==2) return
                this.offModel = false
                this.addBox.showModel = true
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = this.tableList.hasSelectData
                }else{
                    this.addBox.editFormData = {}
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.addBox.showModel = false;
                    this.clearbtnStatus()
                    this.getData();
                }
            },
            addFunc() {  //添加通用功能、参数
               if(this.roleType==2) return
                this.setPageId(null)
                this.offModel = false
                this.addFuncBox.showModel = true
                this.addFuncBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.addBox.showModel = false;
                }
            },
            getData(){ //获取数据

                let cid = this.searchObj.basicClassIdArr[this.searchObj.basicClassIdArr.length-1] || ''
                let params ={
                        basicClassId:cid,
                        ...this.searchObj
                    }
                    delete params.basicClassIdArr
                    let forbiddenObj = {'true':true,'false':false}
                    if(params.forbidden){
                        params.forbidden = forbiddenObj[params.forbidden]
                    }
                    // designImplType:this.designImplType 想获取的是以前的蓝牙和wifi的就送1，当前的lora的就送2，不想区分的话就别送，大类下面的基础型号就全返回

                this.axios.post(this.config.urlArray.typeList,params).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{

                        let resData = result.data.data
    
                        if(resData){
                            this.tableList.tableDataAll  =  resData

                          
    
                            if(!resData.meta){//分页不生效
                                Object.keys(params).forEach(key => {
                                  if (params[key] === '' || params[key] === undefined || params[key] === null) return this.tableList.tableDataAll 
	                            //   this.tableList.tableDataAll = this.tableList.tableDataAll.filter(p => p[key] === null || p[key] === params[key])
                                 

	                              this.tableList.tableDataAll = this.tableList.tableDataAll.filter(p =>{
                                    if(typeof p[key]=='number' || typeof p[key]=='boolean'){
                                        return p[key] === params[key]
                                    }
                                    return p[key] === null || p[key].includes(params[key])
                                  })
                                })
                                this.paging = false
                                this.page.total = resData.length
                                this.getDataPage()
                            }else{
                                this.tableList.tableData = resData
                                this.page.total = resData.meta.count
                            }
                            
                            this.loading = false
                        }else{
                            this.tableList.tableData = []
                            this.page.total = 0
                            this.loading = false
                            return false
                        }
                    })

                })

                // this.axios.post(this.config.urlArray.typeList,params).then((result) => {
                //     let resData = result.data.data
                //     //处理数组
                //     if(resData){
                //         this.tableList.tableData = resData  //渲染数据
                //         this.loading = false
                //     }else{
                //         return false
                //     }
                // })
            },
            getDataPage(){
                let start = (this.page.current-1)*this.page.pageSize
                let end = (this.page.current)*this.page.pageSize
                let key =  this.page.key
                let order = this.page.order

                this.tableList.tableDataAll.sort((a, b) => {
                  const valA = a[key]
                  const valB = b[key]
                
                  if (valA == null || valB == null) return 0 // 空值不排序
                
                  if (typeof valA === 'number' && typeof valB === 'number') {
                    return order === 'asc' ? valA - valB : valB - valA
                  } else {
                    return order === 'asc'
                      ? String(valA).localeCompare(String(valB))
                      : String(valB).localeCompare(String(valA))
                  }
                })


                // this.tableList.tableDataAll = this.tableList.tableDataAll.sort((a,b)=>{
                //     if(order=='asc'){
                //        return  a[key] === b[key] ? 0 : a[key] > b[key] ? 1 : -1
                //     }else if(order=='desc'){
                //        return  b[key] === a[key] ? 0 : b[key] > a[key] ? 1 : -1
                //     }
                    
                // })

                this.page.total =  this.tableList.tableDataAll.length

            
                 this.tableList.tableData = this.tableList.tableDataAll.slice(start,end)

                

            },
            clearbtnStatus() { //删除后清空编辑数据 与按钮状态
                this.buttonList.delDisabled = true
                this.buttonList.editDisabled = true
                this.tableList.hasSelectData = {}
            },
            selectChange(res) { //控制编辑和删除按钮的可用状态
                if(res.length == 1){
                    this.buttonList.editDisabled = this.buttonList.delDisabled = false
                    this.tableList.hasSelectData = res[0]
                }else{
                    this.buttonList.editDisabled = this.buttonList.delDisabled = true
                    this.tableList.hasSelectData = {}
                }
            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                if(this.paging){
                    this.getData()          
                }else{
                    this.page.current = 1
                    this.getDataPage()  
                }
            },
            changePage(nowpage) {//切换分页
                this.page.current = nowpage;
                if(this.paging){
                    this.getData()          
                }else{
                    this.getDataPage()  
                }
            },
            changeSize(nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                if(this.paging){
                    this.getData()          
                }else{
                    this.getDataPage()  
                }
            }
        }
    }
</script>
<style lang="less">
    .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .vertical-center-modal .ivu-modal{
        top: 0;
    }
</style>
<style lang="less" scoped>

  .productsPageCon{
    margin: 42px 40px 8px;
  }
  .ivu-card-bordered{
    border: none;
  }
   .search-div{
     flex-wrap: wrap;
     background-color: #fff;
    //  padding: 34px 40px ;
     background: #FFFFFF;
     margin: 20px 0px 30px;
     border-radius: 14px;
     .search-div-item{
         margin-right: 20px;
         span{
             margin-right: 30px;
         }
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
      /deep/ .ivu-select-single .ivu-select-selection{
        height: 44px;
        width: 200px;
     }
     /deep/  .ivu-input{
          height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-input-icon{
         height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-cascader{
         height: 54px;
         line-height: 54px;
     }
 }
 .labelText{
     line-height: 54px;
     height: 54px;
     flex-shrink: 0;
     margin-right: 10px;
 }
</style>



